import { AppData } from "../types";

const STORAGE_KEY = "schulplanung_data";

export const loadFromStorage = (): AppData => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const data = JSON.parse(stored);

      // Migrate old Fach data to include pflichtfach, freifach, and basislektionen
      if (data.faecher && data.faecher.length > 0) {
        data.faecher = data.faecher.map((fach: any) => {
          const migrated = { ...fach };
          if (!migrated.pflichtfach) {
            migrated.pflichtfach = { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false };
          }
          if (!migrated.freifach) {
            migrated.freifach = { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false };
          }
          return migrated;
        });
      }

      // Migrate old Lehrperson data: pensum (%) → solllektionen
      if (data.lehrpersonen && data.lehrpersonen.length > 0) {
        data.lehrpersonen = data.lehrpersonen.map((lp: any) => {
          if (lp.pensum !== undefined && lp.solllektionen === undefined) {
            const { pensum, ...rest } = lp;
            return {
              ...rest,
              solllektionen: Math.round((pensum / 100) * 24),
            };
          }
          return lp;
        });
      }

      return data;
    }
  } catch (error) {
    console.error("Error loading from storage:", error);
  }

  return {
    lehrpersonen: [],
    klassen: [],
    faecher: [],
    zuteilungen: [],
    gekoppelt: [],
  };
};

export const saveToStorage = (data: AppData): void => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (error) {
    console.error("Error saving to storage:", error);
  }
};

export const generateId = (prefix: string): string => {
  return `${prefix}_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
};
